/* Node size comes from computed layout constants, applied via inline style. */
/* eslint-disable react/forbid-dom-props */
import { Handle, type Node, type NodeProps, Position } from "@xyflow/react";
import React from "react";
import { useTranslation } from "react-i18next";

import { NODE_HEIGHT, NODE_WIDTH } from "./treeGraph.constants";
import type { LinkedTreeNodeData } from "./treeGraph.types";

import styles from "./LinkedTreeNode.module.css";

/** Canvas node for a link to another tree: an evergreen silhouette; clicking navigates to that tree. */
const LinkedTreeNode = ({ data }: NodeProps<Node<LinkedTreeNodeData>>) => {
	const { t } = useTranslation("homePage");

	return (
		<div className={styles.linkedTreeNode} style={{ width: NODE_WIDTH, height: NODE_HEIGHT }}>
			<Handle className={styles.hiddenHandle} id="t" position={Position.Top} type="target" />
			<Handle className={styles.hiddenHandle} id="l" position={Position.Left} type="target" />
			<span className={styles.treeShape}>
				<span className={styles.treeShapeInner}>
					<svg aria-hidden="true" viewBox="0 0 24 24">
						<path d="M12 3v13" />
						<path d="M6 16h12" />
						<path d="M6 16v4M18 16v4M12 16v4" />
					</svg>
				</span>
			</span>
			<span className={styles.title}>{data.title}</span>
			<span className={styles.subtitle}>{t("editor.treeLinks.nodeSubtitle")}</span>
			<Handle className={styles.hiddenHandle} id="b" position={Position.Bottom} type="source" />
			<Handle className={styles.hiddenHandle} id="r" position={Position.Right} type="source" />
		</div>
	);
};

export default LinkedTreeNode;
